import styles from './Typography.module.css';

/** Classes typographiques partagées : le style vient des tokens, pas des composants. */
export const typography = {
  eyebrow: styles.eyebrow,
  heading: styles.heading,
  display: styles.display,
  h2: styles.h2,
  accent: styles.accent,
  lead: styles.lead,
} as const;
